import { formatDate } from "@/lib/utils";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
  Text,
} from "@a7y/tailwind-catalyst";
import { formatCents, PayoutStateBadge, Section } from "../shared";
import type { AffiliatePayout } from "../types";

export function PayoutHistoryTab({ payouts }: { payouts: AffiliatePayout[] }) {
  return (
    <Section title={`Payout History (${payouts.length})`}>
      <Table dense striped>
        <TableHead>
          <TableRow>
            <TableHeader>State</TableHeader>
            <TableHeader>Amount</TableHeader>
            <TableHeader>Commissions</TableHeader>
            <TableHeader>Approved</TableHeader>
            <TableHeader>Stripe payout</TableHeader>
            <TableHeader>Created</TableHeader>
          </TableRow>
        </TableHead>
        <TableBody>
          {payouts.length === 0 ? (
            <TableRow>
              <TableCell colSpan={6} className="py-6 text-center">
                <Text className="text-sm text-zinc-500">No payouts yet</Text>
              </TableCell>
            </TableRow>
          ) : (
            payouts.map((p) => (
              <TableRow key={p.id}>
                <TableCell>
                  <PayoutStateBadge state={p.state} />
                </TableCell>
                <TableCell className="font-medium">
                  {formatCents(p.amountCents, p.currency)}
                </TableCell>
                <TableCell className="text-sm text-zinc-500">{p.commissionIds.length}</TableCell>
                <TableCell className="text-sm text-zinc-500">
                  {p.approvedAt ? formatDate(p.approvedAt) : "—"}
                </TableCell>
                <TableCell className="font-mono text-xs">{p.stripePayoutId || "—"}</TableCell>
                <TableCell className="text-sm text-zinc-500">{formatDate(p.createdAt)}</TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </Section>
  );
}
